export default __webpack_public_path__ + "media/src/assets/images/logo_placeholder-e4e28b3ca7d103ea09618a1c31565565.png";